import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import BookingSearchTable from './BookingSearchTable';

export default withTheme(withRouter(BookingSearchTable));
